import UrlHelper from './url-helper';

const { NODE_ENV } = process.env;

const baseUrl = ( NODE_ENV === 'production' ) ? '/api' : 'http://localhost:9010/api';


const Api = {


    fetchPackage : function* ( packageName, type = null, channel = null, signature = null )
    {
        const url = `${baseUrl}${UrlHelper.getPackageViewUrl( decodeURIComponent( packageName ), type, channel, signature )}`;

        const result = yield fetch( url );

        return yield result.json();
    },


    fetchDoc : function* ( packageName, type = null, channel = null, signature = null )
    {
        const url = `${baseUrl}${UrlHelper.getDocViewUrl( decodeURIComponent( packageName ), type, channel, signature )}`;

        const result = yield fetch( url );

        return yield result.json();
    },


    listPackages : function* ( packageFilter = null, type = null, channel = null, signature = null )
    {
        const url = `${baseUrl}${UrlHelper.getPackageListUrl( packageFilter ? decodeURIComponent( packageFilter ) : packageFilter, type, channel, signature )}`;

        const result = yield fetch( url );

        return yield result.json();
    },


    listDocs : function* ( packageFilter = null, type = null, channel = null, signature = null )
    {
        const url = `${baseUrl}${UrlHelper.getDocListUrl( packageFilter ? decodeURIComponent( packageFilter ) : packageFilter, type, channel, signature )}`;


        const result = yield fetch( url );

        return yield result.json();
    }
};


export default Api;



// WEBPACK FOOTER //
// ./src/lib/api.js